<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "SiteTypes"
};
</script>

<style scoped>
</style>
